<template>
  <ul id="search-results" class="p-0 list-unstyled result-item">
    <li
      v-for="(item, index) in searchResults.slice(10*(currentPage-1),10*(currentPage))"  :key="index"
      class="p-0"
      :class="{'bg-background' : index %2 == 0}"
      ref="sourceItem"
      @click="openList(index+(currentPage*10-10), index)"
    >
      <b-btn         
        variant="link"
        class="bg-transparent shadow-none px-2 h-100"
        >
          <i class="fas fa-bars"></i>
      </b-btn>
      <span class="f-narkis h-100 d-inline-block">{{item.word}}</span> <small>[{{item.sentence_count}} מופעים]</small>     
      <div class="inner-results bg-white mt-1 pt-2 px-4 border-top border-bottom border-secondary">              
       <div v-for="(resultItem, i) in sentences" :key="i" class="pb-2 d-flex">
          <div>
            <i aria-hidden="true" class="mr-1  mt-2 fas fa-square border-right border-bottom text-white"></i>
          </div>  
          <div class="flex-grow-1  mr-2 " >
            <div 
              class="f-narkis inner-pasuk d-inline"
              v-html="formatText(resultItem.sentence, item.word)"
              >
            </div>
            <small v-if="resultItem.hebrew_id" class="mr-2"><a :href="xMLIDToSefariaUrl(resultItem.xml_id)" target="_blank">({{resultItem.hebrew_id}})</a></small>          
          </div>  
        </div>
      </div>  
    </li>
  </ul>
</template>
<script>
  const SINDOT = 'ׂ'
  const SHINDOT = 'ׁ'
  const SHIN = 'ש'
  import {ConvertXMLIDToSefariaUrl} from '@/js/xmlToSefaria'
  import {Actions} from '@/store/stateChanges'
  export default {
    name: 'ResultList',
    props: [ 'searchResults', 'currentPage','perPage'],
    data() {
      return {
        
      }
    },
    methods: {
      formatText(text, word) {
        text = text + ' '
        if(text.split(word + ' ').length > 1)
          return text.split(word + ' ').join('<b>'+word+'</b> ')
        else {
          let wordWithShin = word.split(SHIN)          
          if (wordWithShin.length > 1) {            
            var newWord = ''
            newWord = word.split(SHIN).join(SHIN+SHINDOT)
            if(text.split(newWord).length > 1) { 
              return text.split(newWord).join('<b>'+newWord+'</b>')
            } else{
              newWord = word.split(SHIN).join(SHIN+SINDOT)
              return text.split(newWord).join('<b>'+newWord+'</b>')
            }
          } else {
            return text
          }         
        }  
      },
      xMLIDToSefariaUrl (xmlPasuk) {
        if(xmlPasuk !== '')
          return (ConvertXMLIDToSefariaUrl(xmlPasuk))
      },     
      openList (index, listIndex) {
        if(document.activeElement.tagName !== 'A') {
          const selectedList = this.$refs.sourceItem[listIndex]
          var elems = document.querySelectorAll("li.h-auto");
          [].forEach.call(elems, function(el) {            
            if(el !== selectedList)
              el.classList.remove("h-auto");
          }) 
          this.$store.commit('SET_CURRENT_INDEX',  index)
          if (this.sentenceResults.length < 1) {           
            this.$store.commit('SET_SENTENCE_TEXT_FOR_API_CALL',  this.searchResults[index].word)        
            this.$store.dispatch(Actions.RUN_SENTENCE)
          }  
          else 
            selectedList.classList.toggle('h-auto')               
        }
      }  
    },
    computed: {
      currentIndex () {
        return this.$store.state.currentIndex
      },
      showBible () {
        return this.$store.state.showBible
      },
      showTalmud () {
        return this.$store.state.showBible
      },
      sentences () {
        return this.showBible ? this.sentenceResults.tanach_results : this.sentenceResults.talmud_results
      },
      sentenceResults () {
        return this.showBible ? this.$store.state.bibleSearchApiResponse[this.currentIndex].sentences : 
          this.$store.state.talmudSearchApiResponse[this.currentIndex].sentences
      },
      sentenceLoaded: function () {
        return this.$store.state.sentenceApiState === 'Complete'
      }
    },
    watch: {
      sentenceLoaded (val) {
        if (val) {
          this.openList (this.currentIndex, this.currentIndex%this.perPage)
        }
      },   
      currentPage () {
        if ( this.$refs.sourceItem[this.currentIndex%this.perPage])
          this.$refs.sourceItem[this.currentIndex%this.perPage].classList.remove("h-auto");
      }
    }    
  }  
</script>
<style scoped lang="scss">
  .results {
    margin-top: 7px;
  }
  .f-narkis {font-size: 20px;}
  
  li {      
    height: 36px;
    overflow: hidden;
    //transition:max-height 0.9s ease-out;
    max-height: 36px;
    cursor: pointer;
    .fa-bars {
      color: #8d8d8d;   
    }
    .fa-square {font-size: 11px;vertical-align: top;}
     &:hover {
      .fa-bars {
        color: var(--primary);
      }  
    }
    &.talmud-title {
      height: 65px;
      max-height: 65px;
      padding-top: 30px!important;
      position: relative;
      .position-absolute {
        top: 0;
        cursor: auto;
      }
    }
    &.h-auto {
      max-height: 100%;
    }
  }    
</style>